import { Button, Checkbox, Divider, List, Modal, Space } from "antd";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import React from "react";
import { Service, ServiceOption } from "@/lib/api/types";
interface IExtraOptionsProps {
  service: Service & { option?: ServiceOption };
  showPrice?: boolean;
  onSubmit: (op?: {
    id: string;
    title: string;
    price: number;
    duration: number;
  }) => void;
  onClose: () => void;
}

const ExtraOptions = ({
  service,
  showPrice,
  onSubmit,
  onClose,
}: IExtraOptionsProps) => {
  const defaultOption = {
    id: "",
    title: "Regular",
    price: service.price,
    duration: service.duration,
    description: "",
  };
  const [option, setSelectedOption] = React.useState<ServiceOption>(
    service.option ? service.option : defaultOption
  );

  const onSelect = (op: {
    id: string;
    title: string;
    price: number;
    duration: number;
  }) => {
    setSelectedOption(op);
  };

  const handleSubmit = () => {
    onSubmit(
      option.id === ""
        ? undefined
        : {
            id: option.id,
            title: option.title,
            price: option.price,
            duration: option.duration,
          }
    );
    onClose();
  };

  const enhancedOptions = service.options
    ? [defaultOption, ...service.options]
    : [defaultOption];

  return (
    <Modal
      open={true}
      onCancel={onClose}
      footer={[
        <Button type="primary" key="submit" onClick={handleSubmit}>
          Find Openings
        </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <Title level={5}>Select an option</Title>
      <List
        itemLayout="horizontal"
        dataSource={enhancedOptions}
        renderItem={(item) => {
          return (
            <List.Item>
              <Checkbox
                // disabled={!item.price}
                checked={option.id === item.id ? true : false}
                onClick={() => {
                  onSelect(item);
                }}
              >
                <Text>
                  {item.title}
                  {showPrice && (
                    <>
                      <Divider type="vertical" />
                      {showPrice && (
                        <Text className="is-size-7">${item.price}</Text>
                      )}
                    </>
                  )}
                </Text>
                {item.description && (
                  <>
                    <br />
                    <Text type="secondary" className="is-size-7">
                      {item.description}
                    </Text>
                  </>
                )}
              </Checkbox>
            </List.Item>
          );
        }}
      />
      <Divider />
    </Modal>
  );
};

export default ExtraOptions;
